import React from 'react';
import BarLoader from "react-spinners/BarLoader";

const XLoader = ({ isLoading }) => {


  return (
    <div className='xloader-override'>
      <BarLoader loading={isLoading} />
    </div>
  )
}

export default XLoader;